import { createToast, ToastType } from 'mosha-vue-toastify';
export class Helper {
    static capitalizeFirstLetter(text: string) {
      return text.charAt(0).toUpperCase() + text.slice(1);
    }

    static formatTime(time: string): string {
        const created = new Date(time);

        return created.toLocaleTimeString('en-GB');
    }

    static formatDate(date: string): string {
        const created = new Date(date);
        const newDate = created.toISOString().split('T')[0];
        const [year, month, day] = newDate.split('-');

        return [month, day, year].join('/');
    }

    static checkNamespace(expiringDate:string): boolean{
      const time = new Date(expiringDate);
      const seconds = time.getTime()/1000;
      if(seconds >= 2592000){ // 30 days
        return false;
      }
      return true;
    }

    static endpointErrorHandling(error: any, message?: string, toastType?: ToastType){
      let msg: string;
      if(error.message == 'Network Error'){
        msg = 'Network error. Please try again';
        createToast(
          {
            title: "Whoops!",
            description: 'Network error. Please make sure there is network connection',
          },
          {
            position: "bottom-right",
            type: toastType ? toastType : "danger",
          }
        );
      }else if(message){
        createToast(
          {
            title: "Whoops!",
            description: message,
          },
          {
            position: "bottom-right",
            type: toastType ? toastType : "danger",
          }
        );
      }else{
        msg = error.response.data['message'] ? error.response.data['message']: 'Unable to fetch api';
        createToast(
          {
            title: "Whoops!",
            description: msg,
          },
          {
            position: "bottom-right",
            type: toastType ? toastType : "danger",
          }
        );
      }
      return msg;
    }

    static toastSuccessHandling(responseMessage: any, message?: string): void {
      if (responseMessage && responseMessage !== '') {
        createToast(
          {
            title: "Yay!",
            description: responseMessage ? responseMessage : 'API Success!',
          },
          {
            position: "bottom-right",
            type: "success",
          }
        );
      } else if (message){
        createToast(
          {
            title: "Yay!",
            description: message,
          },
          {
            position: "bottom-right",
            type: "success",
          }
        );
      }
    }

    // Temporary Fix to Date in Transaction
    static getCurrentYearDifference(date: string): string {
        const currentDate = new Date();
        const apiDate = new Date(date);
        const dateDifference = currentDate.getFullYear() - apiDate.getFullYear();
        apiDate.setFullYear(apiDate.getFullYear() + dateDifference);

        const newDate = apiDate.toISOString().split('T')[0];
        const [year, month, day] = newDate.split('-');

        return [month, day, year].join('/');
    }

    /* from Sirius wallet */
    static copyToClipboard (data: string): boolean {
      let textInput: HTMLTextAreaElement;

      try {
        textInput = document.createElement('textarea');
        textInput.style.position = 'fixed';
        textInput.value = data;
        document.body.appendChild(textInput);
        textInput.focus();
        textInput.select();

        const range = document.createRange();
        range.selectNodeContents(textInput);

        const textSelection = window.getSelection();
        textSelection.removeAllRanges();
        textSelection.addRange(range);

        textInput.setSelectionRange(0, textInput.value.length);
        document.execCommand('copy');
      } catch (err) {
        console.error(err);
      } finally {
        document.body.removeChild(textInput);
      }
      return true;
    }

    static convertToCurrency(value: number): string {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

}